export const DATA_HOST = process.env.REACT_APP_DATA_HOST
export const REST_DATA_URL = '/rest/v1/tariffs'
export const AUTH_HOST = process.env.REACT_APP_AUTH_HOST

export const AUTH_USER = 'erv_tariffs_client'
export const AUTH_CREDENTIALS = 'p79&n*u95QHu^qP4D(wktxFnC7vMWtS3'
export const AUTH_SCOPES = 'authUser:read authUser:register authUser:update'

export const USER_USER = 'erv_tariffs_user'
export const USER_CREDENTIALS = 'ywj*m6TDPgZTrv8D%J^37fq!6)CVRc3J'
export const USER_SCOPES = 'tariff:read tariff:write'

export const MIN_PASSWORD_SIZE = 8
export const PASSWORD_SPECIAL_CHARS = '+-.,;:_<>@#+*!§$%&/()=?"\''
